module.exports = __webpack_public_path__ + "static/ARB_Logo-usage_incorrect4-5955bc9847d03dff1a9313b25ecda95e.jpg";